

export function getIsSynchronised(rsc) {
    return (rsc.match("DIV[MW]3MTEAM2.+") || rsc.match("DIV[MW]10MTEAM2.+"));
}

export function getIsIndividual(rsc) {
    return (rsc.match("DIV[MW]3M-.+") || rsc.match("DIV[MW]10M-.+"));

}

export function hasConfig(config) {
    let sw = config.filter(rowConf => rowConf.code === 'INTERMEDIATE').length > 0
    return (
        sw
    )
}
